import http from '@/utils/http';

export default {
    // 商品列表查询 (V2)
    list: (data) => {
        return http({ url: '/api/admin/v2/product/list', data }).then(r => r);
    },
    // 更新商品 (V2)
    update: (data) => {
        return http({ url: '/api/admin/v2/product/update', data, tip: true, loading: true }).then(r => r);
    },
    // 批量更新商品 (V2)
    batchUpdate: (data) => {
        return http({ url: '/api/admin/v2/product/batchUpdate', data, tip: true, loading: true }).then(r => r);
    },
    // 批量导入商品 (V2)
    batchImport: (data) => {
        return http({ url: '/api/admin/v2/product/batchImport', data, tip: true, loading: true }).then(r => r);
    },
    // 供应商列表 (V2)
    supplierListAll: () => {
        return http({ url: '/api/admin/v2/supplier/listAll' }).then(r => r);
    },
    // 采购员列表 (V2)
    purchaserListAll: () => {
        return http({ url: '/api/admin/v2/purchaserUser/listAll' }).then(r => r);
    },
    // 删除商品 (V2)
    delete: (data) => {
        return http({ url: '/api/admin/v2/product/delete', data, tip: true, loading: true }).then(r => r);
    },
};
